<template>
  <div class="mx-1">
    <input
        ref="input"
        accept="image/*"
        name="image"
        type="file"
        @change="setImage"
    />
    <div class="row">
      <div class="col-12 col-lg-7">
        <div class="nv-subhead">
          <v-icon small color="secondary">mdi-content-cut</v-icon>
          <span>Kesilecek Kısmı Seçiniz</span>
        </div>
        <div class="img-cropper">
          <vue-cropper
              ref="cropper"
              :src="signImageInfo.imgSrc"
              :minCanvasWidth="200"
              :minCanvasHeight="200"
              :minContainerWidth="400"
              :minContainerHeight="400"
          />
        </div>
        <div class="actions nv-crop-toolbar">
          <b-button-toolbar>
            <b-button-group class="mr-1">
              <b-button @click="zoom(0.2)" title="Yakınlaştır" id="zoomInBtn">
                <b-icon icon="zoom-in" aria-hidden="true"></b-icon>
              </b-button>
              <b-tooltip target="zoomInBtn" triggers="hover">
                <b>Yakınlaştır</b>
              </b-tooltip>
              <b-button @click="zoom(-0.2)" title="Uzaklaştır" id="zoomOutBtn">
                <b-icon icon="zoom-out" aria-hidden="true"></b-icon>
              </b-button>
              <b-tooltip target="zoomOutBtn" triggers="hover">
                <b>Uzaklaştır</b>
              </b-tooltip>
            </b-button-group>
            <b-button-group class="mr-1">
              <b-button @click="rotate(90)" title="Sağa Döndür" id="degRightBtn">
                <b-icon icon="arrow-90deg-right" aria-hidden="true"></b-icon>
              </b-button>
              <b-tooltip target="degRightBtn" triggers="hover">
                <b>Sağa Döndür</b>
              </b-tooltip>
              <b-button @click="rotate(-90)" title="Sola Döndür" id="degLeftBtn">
                <b-icon icon="arrow-90deg-left" aria-hidden="true"></b-icon>
              </b-button>
              <b-tooltip target="degLeftBtn" triggers="hover">
                <b>Sola Döndür</b>
              </b-tooltip>
            </b-button-group>
            <b-button-group class="mr-1">
              <b-button @click="cropImage" title="Kırp" id="cropImageBtn">
                <b-icon icon="crop" aria-hidden="true"></b-icon>
              </b-button>
              <b-tooltip target="cropImageBtn" triggers="hover">
                <b>Kırp</b>
              </b-tooltip>
              <b-button @click="reset" title="Sıfırla" id="resetBtn">
                <b-icon icon="arrows-fullscreen" aria-hidden="true"></b-icon>
              </b-button>
              <b-tooltip target="resetBtn" triggers="hover">
                <b>Pozisyonu Sıfırla</b>
              </b-tooltip>
              <b-button id="showFileChooserBtn" @click="showFileChooser" title="Dosya Yükle / Değiştir">
                <b-icon icon="upload" aria-hidden="true"></b-icon>
              </b-button>
              <b-tooltip target="showFileChooserBtn" triggers="hover">
                <b>Dosya Yükle / Değiştir</b>
              </b-tooltip>
              <b-button @click="download" title="Resmi İndir" id="downloadBtn">
                <b-icon icon="download" aria-hidden="true"></b-icon>
              </b-button>
              <b-tooltip target="downloadBtn" triggers="hover">
                <b>Resmi İndir</b>
              </b-tooltip>
            </b-button-group>
          </b-button-toolbar>
        </div>
      </div>
      <div class="col-12 col-lg-5">
        <div class="nv-subhead">
          <v-icon small color="secondary">mdi-cloud-upload-outline</v-icon>
          <span>Yüklenecek İmza</span>
        </div>
        <div class="cropped-image nv-crop-preview d-flex justify-center align-center h-400px">
          <img v-if="signImageInfo.cropImg" :src="signImageInfo.cropImg" alt="Cropped Image"/>
          <div v-else class="crop-placeholder"/>
        </div>
        <p class="nv-hint">
          <v-icon x-small>mdi-information-outline</v-icon>
          Görseli yükledikten sonra imza alanını seçip <b>Kırp</b> butonuna basınız.
        </p>
      </div>
    </div>
  </div>
</template>


<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default {
  components: {
    VueCropper
  },
  created() {
    this.signImageInfo.imgSrc = "media/bg/SignerTemplate.png"
    this.signImageInfo.cropImg = this.signImageInfo.imgSrc
  },
  data() {
    return {
      signImageInfo: {
        imgSrc: "",
        cropImg: "",
        fileExtension: "png",
      }
    };
  },
  methods: {
    cropImage() {
      let imgSizes = {
        width: 120,
        height: 80
      }
      let imgBase64 = this.$refs.cropper.getCroppedCanvas().toDataURL();
      let img = new Image()
      img.src = imgBase64
      let canvas = document.createElement('canvas');
      canvas.width = imgSizes.width;
      canvas.height = imgSizes.height;
      var canvasContext = canvas.getContext('2d');
      canvasContext.drawImage(img, 0, 0, imgSizes.width, imgSizes.height);
      this.signImageInfo.cropImg = canvas.toDataURL()
      this.$emit("content", this.signImageInfo);
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    reset() {
      this.$refs.cropper.reset();
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    setImage(e) {
      const file = e.target.files[0];
      if (file) {
        this.signImageInfo.fileExtension = file.name.split(".").pop();
        if (file.type.indexOf("image/") === -1) {
          alert("Please select an image file");
          return;
        }

        if (typeof FileReader === "function") {
          const reader = new FileReader();

          reader.onload = event => {
            this.signImageInfo.imgSrc = event.target.result;
            // rebuild cropperjs with the updated source
            this.$refs.cropper.replace(event.target.result);
          };

          reader.readAsDataURL(file);
        } else {
          alert("Sorry, FileReader API not supported");
        }
      }
    },
    showFileChooser() {
      this.$refs.input.click();
    },
    download() {
      if (this.signImageInfo.cropImg) {
        var extention = this.signImageInfo.fileExtension;
        var href = this.signImageInfo.cropImg;
        var link = document.createElement("a");
        link.addEventListener(
            "click",
            function () {
              link.href = href;
              link.download = "İmza." + extention;
            },
            false
        );
        link.click();
      } else {
        alert("Please, crop image before download it");
      }
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    }
  }
}
</script>

<style>
input[type="file"] {
  display: none;
}

.content {
  display: flex;
  justify-content: space-between;
}

.actions {
  margin-top: 1rem !important;
}

.preview-area p:last-of-type {
  margin-top: 1rem;
}

.preview {
  width: 100%;
  height: calc(372px * (9 / 16));
  overflow: hidden;
}

.cropped-image img {
  max-width: 100% !important;
}

.cropper-bg {
  background-repeat: repeat;
}

.cropper-min-height {
  min-height: 400px !important;
}

.cropper-container {
  width: 100% !important;
}
</style>
